import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import {
    catchError,
    concatMap,
    endWith,
    flatMap,
    map,
    mergeAll,
    mergeMap,
    startWith,
    switchMap,
    take
} from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

const getVehicleGroups = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.GENERAL_FUEL_REPORT.GET_VEHICLE_GROUPS),
        mergeMap((action) => {
            const api = async () => {
                const vehicleGroups = await CONSTANTS.FUNCTION.AXIOS.GET(
                    CONSTANTS.URL.GENERAL_FUEL_REPORT.GET_VEHICLE_GROUPS
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_VEHICLE_GROUPS,
                        vehicleGroups.data.data
                    )
                )
                return arrayAction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const getVehicleByGroup = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.GENERAL_FUEL_REPORT.POST_VEHICLES_BY_GROUP),
        mergeMap((action) => {
            const api = async () => {
                const vehicleList = await CONSTANTS.FUNCTION.AXIOS.POST(
                    `${CONSTANTS.URL.GENERAL_FUEL_REPORT.POST_VEHICLES_BY_GROUP}?vehicle_group_id=${action.payload.vehicle_group_id}`,
                    {}
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_VEHICLES_BY_GROUP,
                        vehicleList.data.data
                    )
                )
                return arrayAction
            }
            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postReportExtendDataAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.GENERAL_FUEL_REPORT.POST_REPORT_EXTEND_DATA_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const newPayload = {
                    ...action.payload,
                    from_date: CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(action.payload.from_date),
                    to_date: CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(action.payload.to_date)
                }
                const reportData = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.GENERAL_FUEL_REPORT.POST_REPORT_EXTEND_DATA_ACTION,
                    newPayload
                )
                let arrayAction = []

                reportData.data.status
                    ? arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              "Tải dữ liệu thành công"
                          )
                      )
                    : arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              Array.isArray(reportData.data.data) && reportData.data.data.length === 0
                                  ? "Không có dữ liệu báo cáo"
                                  : "Lỗi trong lúc tải dữ liệu"
                          )
                      )

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_REPORT_EXTEND_DATA_ACTION,
                        reportData.data.data
                    )
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postDownloadExtendReportAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.GENERAL_FUEL_REPORT.POST_DOWNLOAD_EXTEND_REPORT_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const newPayload = {
                    from_date: CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(action.payload.from_date),
                    to_date: CONSTANTS.FUNCTION.COMMON.convertDateToStringCommonFormat(action.payload.to_date),
                    group_by: action.payload.group_by,
                    vehicle_id_list: action.payload.vehicle_id_list
                }
                const downloadFile = await CONSTANTS.FUNCTION.AXIOS.POST_DOWNLOAD_FILE(
                    CONSTANTS.URL.GENERAL_FUEL_REPORT.POST_DOWNLOAD_EXTEND_REPORT_ACTION +
                        `${action.payload.export_type}`,
                    newPayload
                )

                let arrayAction = []

                if (downloadFile.status !== 200 || downloadFile.statusText !== "OK") {
                    arrayAction.push(
                        CONSTANTS.FUNCTION.REDUX.DISPATCH(
                            CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                            "Lỗi trong lúc tải dữ liệu"
                        )
                    )
                    return arrayAction
                }

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(
                        CONSTANTS.ACTION.GENERAL_FUEL_REPORT.SET_DOWNLOAD_EXTEND_REPORT_ACTION,
                        {
                            data: downloadFile.data
                        }
                    )
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )
export default {
    getVehicleGroups,
    getVehicleByGroup,
    postReportExtendDataAction,
    postDownloadExtendReportAction
}
